module.exports = __webpack_public_path__ + "img/a14.442edf1c.png";